<template>
    <CRow>
        <CCol>
            <div>
                <CRow>
                    <CCol 
                        tag="label" 
                        sm="3"
                        class="col-form-label font-bold">
                        Время активности
                    </CCol>
                    <CCol v-if="!onlyShow">
                        <CButton color="primary" class="mr-3" @click="create">
                            Добавить
                        </CButton>
                    </CCol>
                </CRow>
                <table class="mt-2">
                    <template>
                        <thead>
                            <tr>
                                <th class="working-hours_fix-table">Начало действия</th>
                                <th class="working-hours_fix-table">Окончание действия</th>
                                <th class="working-hours_fix-table">Активен</th>
                                <th class="working-hours_fix-table" v-if="!onlyShow"></th>
                                <th class="working-hours_fix-table" v-if="!onlyShow"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in slots" :key="item.id">
                                <td class="working-hours_fix-table">{{ scheduleFormated(item.open_weekday, item.open_hours, item.open_minutes) }}</td>
                                <td class="working-hours_fix-table">{{ scheduleFormated(item.close_weekday, item.close_hours, item.close_minutes) }}</td>
                                
                                <td class="working-hours_fix-table">
                                    <CBadge :color="getBadge(item.enabled)">
                                        &nbsp;{{item.enabled ? 'Да' : 'Нет' }}&nbsp;
                                    </CBadge>
                                </td>
                                <td class="working-hours_fix-table" align="right" v-if="!onlyShow">
                                    <CButton @click="edit(item)">
                                        <CIcon :content="$options.icons.cilPencil" class="handle"></CIcon>
                                    </CButton>
                                </td>
                                <td v-if="!onlyShow">
                                    <CButton @click="removeItem(item)">
                                        <CIcon :content="$options.icons.cilTrash" class="handle"></CIcon>
                                    </CButton>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </table>
            </div>
        </CCol>

        <CModal
            :show.sync="editModal"
            title="Время работы"
            width="800px"
        >
                    <CForm>
                        <CRow>
                            <CCol>
                                <h3 class="font-bold">Начало действия</h3>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol cols="6">
                                <CSelect
                                    v-model="editSchedule.open_weekday"
                                    label="День недели"
                                    :options="weekdays"
                                    item-text="title"
                                    item-value="value"
                                    outlined
                                    hide-details
                                />
                            </CCol>
                            <CCol cols="3">
                                <CInput
                                    v-model="editSchedule.open_hours"
                                    outlined
                                    label="Часы"
                                    hide-details
                                />
                            </CCol>
                            <CCol cols="3">
                                <CInput
                                    v-model="editSchedule.open_minutes"
                                    outlined
                                    label="Минуты"
                                    hide-details
                                />
                            </CCol>
                        </CRow>
                        <CRow class="mt-3">
                            <CCol>
                                <h3 class="font-bold">Окончание действия</h3>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol cols="6">
                                <CSelect
                                    v-model="editSchedule.close_weekday"
                                    label="День недели"
                                    :options="weekdays"
                                    item-text="title"
                                    item-value="value"
                                    outlined
                                    hide-details
                                />
                            </CCol>
                            <CCol cols="3">
                                <CInput
                                    v-model="editSchedule.close_hours"
                                    outlined
                                    label="Часы"
                                    hide-details
                                />
                            </CCol>
                            <CCol cols="3">
                                <CInput
                                    v-model="editSchedule.close_minutes"
                                    outlined
                                    label="Минуты"
                                    hide-details
                                />
                            </CCol>
                        </CRow>
                        <CRow class="mt-3">
                            <CCol class="flex mt-1 mb-1">
                                <span class="mr-2">Активен</span>
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="editSchedule.enabled"
                                />
                            </CCol>
                        </CRow>
                    </CForm>
                <br>
                <div slot="footer">
                    <CButton
                        color="danger"
                        class="mr-3"
                        @click="removeModal"
                    >Удалить</CButton>
                    <CButton
                        color="primary"
                        class="ml-3"
                        @click="save"
                    >Сохранить</CButton>
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="editModal = false"
                    >Отмена</CButton>
                </div>
        </CModal>
    </CRow>
</template>

<script>
    import { cilPlus, cilTrash, cilPencil } from '@coreui/icons';

    export default {
        name: 'DemandSchedule',

        icons: {
            cilPlus,
            cilTrash,
            cilPencil
        },

        props: {
            scheduleList: {
                type: Array,
                default: () => []
            },
            entityId: {
                type: Number
            },
            onlyShow: {
                type: Boolean,
                default: false
            },
        },

        data() {
            return {
                isAuthorized: false,
                editModal: false,
                editSchedule: {},
                weekdays: [
                    { value: 1, label: 'понедельник' },
                    { value: 2, label: 'вторник' },
                    { value: 3, label: 'среда' },
                    { value: 4, label: 'четверг' },
                    { value: 5, label: 'пятница' },
                    { value: 6, label: 'суббота' },
                    { value: 0, label: 'воскресенье' },
                ],
                slots: [],
            };
        },

        async mounted() {

        },

        watch: {
            scheduleList: function () {
                this.setModel();
            },
        },

        created() {
            this.setModel();
        },

        methods: {
            setModel() {
                this.slots = this.scheduleList;
            },
            create() {
                this.editSchedule = {
                    demand_id: +this.entityId,
                    open_weekday: 0,
                    open_hours: 0,
                    open_minutes: 0,
                    close_weekday: 0,
                    close_hours: 0,
                    close_minutes: 0,
                    enabled: false,
                    sort: 0,
                    id: null,
                };
                this.editModal = true;
            },
            edit(item) {
                this.editSchedule = JSON.parse(JSON.stringify(item));
                this.editModal = true;
            },
            scheduleFormated(weekDay, hours, minutes) {
                weekDay = this.weekdays.find((item) => item.value === weekDay).label;
                if (hours < 10) {
                    hours = `0${hours}`;
                }
                if (minutes < 10) {
                    minutes = `0${minutes}`;
                }
                return `${weekDay} - ${hours}:${minutes}`;
            },
            async save() {
                try {
                    this.editSchedule.open_weekday = +this.editSchedule.open_weekday;
                    this.editSchedule.open_hours = +this.editSchedule.open_hours;
                    this.editSchedule.open_minutes = +this.editSchedule.open_minutes;
                    this.editSchedule.close_weekday = +this.editSchedule.close_weekday;
                    this.editSchedule.close_hours = +this.editSchedule.close_hours;
                    this.editSchedule.close_minutes = +this.editSchedule.close_minutes;
                    this.editSchedule.enabled = !!this.editSchedule.enabled;

                    if (this.editSchedule && this.editSchedule.id) {
                        await this.axios.put(`/demands/schedules/${+this.editSchedule.id}`, this.editSchedule);
                    } else if (this.editSchedule) {
                        delete this.editSchedule.id;
                        await this.axios.post('/demands/schedules', this.editSchedule);
                    }
                    this.$emit('updated');
                    this.editModal = false;
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка сохранения. ' + err);
                }
            },
            async removeModal() {
                try {
                    if (this.editSchedule && this.editSchedule.id) {
                        await this.axios.delete(`/demands/schedules/${this.editSchedule.id}`);
                        this.editModal = false;
                        this.$emit('updated');
                    }
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка удаления. ' + err);
                }
            },
            removeItem(item) {
                this.editSchedule = item;
                this.removeModal();
            },
            getBadge (status) {
                return status ? 'success' : 'secondary'
            },
        },
    };
</script>
<style scoped>
    .working-hours_fix-table {
        padding-right: 30px;
    }
</style>